import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/gigs.css";
import ReactDOM from "react-dom";
import AdminMenu from './adminMenu';

const API_BASE_URL =
    window.location.hostname === "localhost" ||
    window.location.hostname.startsWith("10.")
        ? "https://localhost:7022/api"
        : "https://www.dysband.com/api";

export default function GigsTable({ setIsAuthenticated }) {
    const [gigs, setGigs] = useState([]);

    // TOGGLE STATE
    const [showPastGigs, setShowPastGigs] = useState(false);

    const emptyGig = {
        title: "",
        clientName: "",
        clientPhone: "",
        clientEmail: "",
        venueName: "",
        venueAddress: "",
        startDateTime: "",
        endDateTime: "",
        payAmount: "",
        depositAmount: "",
        depositPaid: false,
        depositPaidDate: "",
        fullyPaid: false,
        fullyPaidDate: "",
        status: "",
        notes: "",
        privateNotes: ""
    };

    const [formGig, setFormGig] = useState(emptyGig);
    const [showModal, setShowModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [selectedGigId, setSelectedGigId] = useState(null);

    // Load gigs
    useEffect(() => {
        fetchGigs();
    }, []);

    const fetchGigs = async () => {
        try {
            console.log("FETCH URL:", `${API_BASE_URL}/Gigs`);

            const res = await axios.get(`${API_BASE_URL}/Gigs`);

            setGigs(res.data);
        } catch (err) {
            console.error("FETCH ERROR:", err.response || err);
            alert("Could not fetch gigs from the server.");
        }
    };

    const openAddModal = () => {
        setFormGig(emptyGig);
        setIsEdit(false);
        setSelectedGigId(null);
        setShowModal(true);
    };

    const openEditModal = (gig) => {
        setFormGig({
            ...gig,
            startDateTime: gig.startDateTime?.slice(0, 16),
            endDateTime: gig.endDateTime?.slice(0, 16)
        });

        setSelectedGigId(gig.id);
        setIsEdit(true);
        setShowModal(true);
    };

    const closeModal = () => setShowModal(false);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        setFormGig((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value
        }));
    };

    const handleSaveGig = async (e) => {
        e.preventDefault();

        const gigToSend = {
            ...(isEdit && { Id: selectedGigId }),
            Title: formGig.title || "",
            ClientName: formGig.clientName || "",
            ClientPhone: formGig.clientPhone || "",
            ClientEmail: formGig.clientEmail || "",
            VenueName: formGig.venueName || "",
            VenueAddress: formGig.venueAddress || "",
            StartDateTime: formGig.startDateTime,
            EndDateTime: formGig.endDateTime || null,
            PayAmount: formGig.payAmount
                ? Number(formGig.payAmount)
                : null,
            DepositAmount: formGig.depositAmount
                ? Number(formGig.depositAmount)
                : null,
            DepositPaid: formGig.depositPaid,
            DepositPaidDate: formGig.depositPaid
                ? new Date().toISOString()
                : null,
            FullyPaid: formGig.fullyPaid,
            FullyPaidDate: formGig.fullyPaid
                ? new Date().toISOString()
                : null,
            Status: formGig.status || "",
            Notes: formGig.notes || "",
            PrivateNotes: formGig.privateNotes || ""
        };

        console.log(
            "Sending to API:",
            isEdit
                ? `${API_BASE_URL}/gigs/${selectedGigId}`
                : `${API_BASE_URL}/gigs`
        );

        console.log("Payload:", gigToSend);

        try {
            if (isEdit) {
                await axios.post(
                    `${API_BASE_URL}/Gigs/${selectedGigId}`,
                    gigToSend
                );
            } else {
                await axios.post(`${API_BASE_URL}/Gigs`, gigToSend);
            }

            fetchGigs();
            closeModal();
        } catch (err) {
            console.error("SAVE ERROR:", err);

            if (err.response) {
                console.log("Status:", err.response.status);
                console.log("Data:", err.response.data);
            }

            alert("Could not save gig. Check console for details.");
        }
    };

    const handleUploadClick = (gigId) => {
        document.getElementById(`file-${gigId}`).click();
    };

    const handleFileChange = async (e, gigId) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append("file", file);
        formData.append("gigId", gigId);

        try {
            await axios.post(`${API_BASE_URL}/Gigs/upload-contract`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            });

            e.target.value = "";
            alert("Contract uploaded successfully");
            fetchGigs();
        } catch (err) {
            console.error(err);
            alert("Upload failed");
            e.target.value = "";
        }
    };

    // FILTER GIGS
    const now = new Date();

    const upcomingGigs = gigs.filter((gig) => {
        if (!gig.startDateTime) return false;

        return new Date(gig.startDateTime) >= now;
    });

    // DISPLAYED GIGS
    const displayedGigs = showPastGigs
        ? gigs
        : upcomingGigs;

    return (
        <div className="admin-container gigs">
            <AdminMenu setIsAuthenticated={setIsAuthenticated} />

            <div className="container">
                <h2>Upcoming Gigs</h2>

                <button
                    className="add-btn"
                    onClick={openAddModal}
                >
                    + Add Gig
                </button>

                {/* TOGGLE */}
                <div className="gig-toggle">
                    <label>
                        <input type="checkbox" checked={showPastGigs} onChange={(e) =>
                                setShowPastGigs(e.target.checked)
                            }
                        />
                        Show Past Gigs
                    </label>
                </div>

                <div className="gigs-table-container">
                    <table className="gigs-table">
                        <thead>
                            <tr>
                                <th>Event Date</th>
                                <th>Client</th>
                                <th>Client Phone</th>
                                <th>Client Email</th>
                                <th>Venue</th>
                                <th>Address</th>
                                <th>Band Fee</th>
                                <th>Deposit Amount</th>
                                <th>Deposit Paid</th>
                                <th>Deposit Date</th>
                                <th>Booked By:</th>
                                <th>Notes</th>
                                <th>Edit Details</th>
                                <th>Add/View Contract</th>
                            </tr>
                        </thead>

                        <tbody>
                            {displayedGigs.map((gig) => (
                                <tr key={gig.id}>
                                    <td>
                                        {new Date(
                                            gig.startDateTime
                                        ).toLocaleString()}
                                    </td>

                                    <td>{gig.clientName}</td>

                                    <td>{gig.clientPhone}</td>

                                    <td>{gig.clientEmail}</td>

                                    <td>{gig.venueName}</td>

                                    <td>{gig.venueAddress}</td>

                                    <td>{gig.payAmount}</td>

                                    <td>{gig.depositAmount}</td>

                                    <td>
                                        <input type="checkbox"checked={gig.depositPaid} readOnly />
                                    </td>

                                    <td>
                                        {gig.depositPaidDate ? new Date(gig.depositPaidDate).toLocaleDateString() : ""}
                                    </td>

                                    <td>{gig.status}</td>

                                    <td>{gig.notes}</td>

                                    <td>
                                        <button className="edit-btn" onClick={() => openEditModal(gig) }>Edit </button>
                                    </td>

                                    <td>
    {(() => {
        const contractUrl =
            gig.contractUrl || gig.ContractUrl;

        const fullUrl = contractUrl
            ? `${API_BASE_URL.replace("/api", "")}${contractUrl}`
            : null;

        return (
            <div className="contract-actions">
                {fullUrl ? (
                    <>
                        <button
                            className="view-btn"
                            onClick={() =>
                                window.open(fullUrl, "_blank")
                            }
                        >
                            View PDF
                        </button>

                        <button
                            className="replace-btn"
                            onClick={() =>
                                handleUploadClick(gig.id)
                            }
                        >
                            Replace PDF
                        </button>
                    </>
                ) : (
                    <button
                        className="upload-btn"
                        onClick={() =>
                            handleUploadClick(gig.id)
                        }
                    >
                        Upload PDF
                    </button>
                )}

                <input
                    type="file"
                    accept="application/pdf"
                    style={{ display: "none" }}
                    id={`file-${gig.id}`}
                    onChange={(e) =>
                        handleFileChange(e, gig.id)
                    }
                />
            </div>
        );
    })()}
</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {showModal &&
                    ReactDOM.createPortal(
                        <div className="modal-overlay">
                            <div className="modal">
                                <h3> {isEdit? "Edit Gig": "Add Gig"} </h3>

                                <form
                                    onSubmit={handleSaveGig}
                                    className="modal-form"
                                >
                            <div className="form-group">
                                <label htmlFor="title">Title</label>
                                <input id="title" name="title" value={formGig.title} onChange={handleChange} required />
                            </div>

                            <div className="form-group">
                                <label htmlFor="clientName">Client Name</label>
                                <input id="clientName" name="clientName" value={formGig.clientName} onChange={handleChange} required />
                            </div>

                            <div className="form-group">
                                <label htmlFor="clientPhone">Client Phone</label>
                                <input id="clientPhone" name="clientPhone" value={formGig.clientPhone} onChange={handleChange} />
                            </div>

                            <div className="form-group">
                                <label htmlFor="clientEmail">Client Email</label>
                                <input id="clientEmail" name="clientEmail" type="email" value={formGig.clientEmail} onChange={handleChange} />
                            </div>

                            <div className="form-group">
                                <label htmlFor="venueName">Venue Name</label>
                                <input id="venueName" name="venueName" value={formGig.venueName} onChange={handleChange} required />
                            </div>

                            <div className="form-group">
                                <label htmlFor="venueAddress">Venue Address</label>
                                <input id="venueAddress" name="venueAddress" value={formGig.venueAddress} onChange={handleChange} />
                            </div>

                            <div className="form-group">
                                <label htmlFor="startDateTime">Start Date & Time</label>
                                <input id="startDateTime" type="datetime-local" name="startDateTime" value={formGig.startDateTime} onChange={handleChange} required />
                            </div>

                            <div className="form-group">
                                <label htmlFor="endDateTime">End Date & Time</label>
                                <input id="endDateTime" type="datetime-local" name="endDateTime" value={formGig.endDateTime} onChange={handleChange} />
                            </div>

                            <div className="form-group">
                                <label htmlFor="payAmount">Band Fee</label>
                                <input id="payAmount" type="number" name="payAmount" value={formGig.payAmount || ""} onChange={handleChange} />
                            </div>

                            <div className="form-group">
                                <label htmlFor="depositAmount">Deposit Amount</label>
                                <input id="depositAmount" type="number" name="depositAmount" value={formGig.depositAmount || ""} onChange={handleChange} />
                            </div>

                            <div className="form-group">
                                <label htmlFor="depositPaid">Deposit Paid</label>
                                <input id="depositPaid" type="checkbox" name="depositPaid" checked={formGig.depositPaid || false} onChange={handleChange} />
                            </div>

                            <div className="form-group">
                                <label htmlFor="depositPaidDate">Deposit Date</label>
                                <input id="depositPaidDate" type="date" name="depositPaidDate" value={formGig.depositPaidDate || ""} onChange={handleChange} />
                            </div>

                            <div className="form-group">
                                <label htmlFor="status">Booked By</label>
                                <input id="status" name="status" value={formGig.status} onChange={handleChange} />
                            </div>

                            <div className="form-group">
                                <label htmlFor="notes">Notes</label>
                                <textarea id="notes" name="notes" value={formGig.notes} onChange={handleChange}></textarea>
                            </div>

                                    <div className="modal-buttons">
                                        <button
                                            type="button"
                                            className="cancel-btn"
                                            onClick={closeModal}
                                        >
                                            Cancel
                                        </button>

                                        <button
                                            type="submit"
                                            className="save-btn"
                                        >
                                            {isEdit
                                                ? "Save Changes"
                                                : "Add Gig"}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>,
                        document.body
                    )}
            </div>
        </div>
    );
}